<template>
  <div />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CookieSetter',
  props: {
    cookieName: {
      type: String,
      default: '',
    },
    cookieValue: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    ...mapState({
      isConsentGiven: (state) => state.cookies.isConsentGiven,
    }),
  },
  watch: {
    isConsentGiven(current) {
      if (current) {
        const isCookieAlreadySet = this.$cookies.get(this.cookieName);

        if (!isCookieAlreadySet) {
          this.$cookies.set(this.cookieName, this.cookieValue, '1y');
        }
      }
    },
  },
};
</script>

<style lang="postcss"></style>
